<template>
  <LayoutGradient :title="$t('core_sectors.form.setores')" icon="fa-medkit">
    <template v-slot:headerRight>
      <b-btn-group>
        <b-btn variant="outline-info" @click="$router.back()">
          <i class="fas fa-arrow-left"/> {{ $t('sideBar.voltar') }}
        </b-btn>
      </b-btn-group>
    </template>
    <div class="m-3 mt-n10">
      <b-card>
        <SimpleForm :fields="fields" :model="model" @submit="onSubmit">
          <template v-slot:field(core_care_unit.core_care_unit_id)>
            <b-form-group :label="$t('core_sectors.form.unidade_atendimento_principal')">
              <SelectCoreCareUnits :model="careUnit" @input="evt => model.core_care_unit_id = (evt) ? evt.value : null " />
            </b-form-group>
          </template>
        </SimpleForm>
      </b-card>
    </div>
  </LayoutGradient>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import LayoutGradient from "@/templates/LayoutGradient";
import SimpleForm from "@/components/FormGenerator/SimpleForm";
import SectorsRepository from "@/repositories/SectorsRepository";
import SelectCoreCareUnits from "@/pages/corecareunits/components/SelectCoreCareUnits";

export default {
  name: "Form",
  components: {SelectCoreCareUnits, SimpleForm, LayoutGradient},
  computed: {
    ...mapGetters({
      careUnits: 'corecareunits/all',
      setor: 'coresectors/current',
      isLoading: 'coresectors/isLoading'
    }),
    careUnit() {
      if (this.model.core_care_unit_id && this.careUnits) {
        const model = this.careUnits.find(c => this.model.core_care_unit_id === c.id)
        if (model) {
          return {
            value: model.id,
            label: model.name
          }
        }        
      }
      return {}
    }
  },
  data() {
    return {
      fields: [
        {
          fieldsetLabel: this.$t('core_sectors.form.informacoes'),
          fieldset: 'info',
          fields: [
            {label: this.$t('core_sectors.form.nome'), name: 'name', description: this.$t('core_sectors.form.nome_descricao'),},
            {label: this.$t('core_sectors.form.mnemonico'), name: 'mnemonic', description: this.$t('core_sectors.form.mnemonico_descricao')},
            {label: 'Veus ID', name: 'veus_sector_id', description: this.$t('core_sectors.form.veus_id_descricao'), type: 'number'},
          ]
        },
        {
          fieldsetLabel: this.$t('core_sectors.form.vinculo'),
          fieldset: 'core_care_unit',
          fields: [
            {label: this.$t('core_sectors.form.unidade_atendimento_principal'), name: 'core_care_unit_id', description: this.$t('core_sectors.form.unidade_atendimento_principal_descricao')},
          ]
        }
      ],
      model: {
        id: null,
        name: '',
        mnemonic: '',
        veus_sector_id: null,
        core_care_unit_id: null,
      },
      importing: {
        param: 'nome',
        text: null,
        id: null
      }
    }
  },
  methods: {
    ...mapActions([
      'coresectors/listOne',
      'corecareunits/search',
    ]),
    onSubmit() {
      if (this.$route.params.id) {
        this.update()
      }else {
        this.create()
      }
    },
    create() {
      SectorsRepository.post(this.model).then(() => {
        this.$snotify.success(this.$t('core_sectors.form.setor_criado_sucesso'))
        this.$router.push({name: 'coresectors.index'})
      }).catch(error => {
        if (error.response.status === 422) {
          SectorsRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    },
    update() {
      SectorsRepository.put(this.setor.id, this.model).then(() => {
        this.$snotify.success(this.$t('core_sectors.form.setor_atualizado_sucesso'))
        this.$router.push({name: 'coresectors.index'})
      }).catch(error => {
        if (error.response.status === 422) {
          SectorsRepository.toastValidationErrors(error, this.$snotify)
        }
      })
    }
  },
  async mounted() {
    this.$store.commit('coresectors/setCurrent', {})
    if (this.$route.params.id) {
      await this['coresectors/listOne'](this.$route.params.id)
      this.model = {...this.model, ...this.setor}
      if (this.careUnits.filter(c => this.setor.core_care_unit_id === c.id).length === 0){
        this['corecareunits/search']({filters: [['id', '=', this.setor.core_care_unit_id]]})
      }
    }
  }
}
</script>